import { render, staticRenderFns } from "./all_users.vue?vue&type=template&id=10612a73"
import script from "./all_users.vue?vue&type=script&lang=js"
export * from "./all_users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports